import { render, staticRenderFns } from "./NationalTrademarkSearchResponsibleList.vue?vue&type=template&id=5a16466c&"
import script from "./NationalTrademarkSearchResponsibleList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkSearchResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkSearchResponsibleList.vue?vue&type=style&index=0&id=5a16466c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports